import React from 'react';
import Carrier from '../../../models/Carrier';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, TableContainer, Stack } from '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';


export const carrierStatus = [1, 2, 3, 4, 0]

export type CarrierStatus = typeof carrierStatus[number]

export const carrierStatusToDescription = (type: CarrierStatus): string => {
  switch (type) {
    case 1: return "active"
    case 2: return "unsubscribed"
    case 3: return "debtor"
    case 4: return "other"
    case 0: return "inactive"
  }
  return "not"
}

export interface Row {
  data: Carrier
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  onChangePage?: (page: number) => void;
  onClickInfo?: (carrier: Carrier) => void;
}

const Carriers: React.FC<Props> = (props) => {
  const { t } = useTranslation('carrier')
  
  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - var(--header-height)', borderRadius: "10px", margin: "10px", minWidth: "770px" }}>
      <ISTableTitle title={t('title')} />
      <TableContainer sx={{ overflowX: 'auto', height: '100%' }}>
        <Table size="medium" stickyHeader={true}>
          <TableHead >
            <TableRow selected={true}>
              <ISTableHeaderCell align='right'>{t('code')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('name')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('address')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('zipCode')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('locality')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('phoneNumber')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('status')}</ISTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!props.loading && props.rows.map((row, index) =>
              <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{ cursor: 'pointer' }}
                onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
                <TableCell align='right'>{row.data.codigo_transporte}</TableCell>
                <TableCell>{row.data.nombre}</TableCell>
                <TableCell>{row.data.domicilio}</TableCell>
                <TableCell>{row.data.codigopostal}</TableCell>
                <TableCell>{row.data.localidad}</TableCell>
                <TableCell>{row.data.telefono}</TableCell>
                <TableCell>{t(`${carrierStatusToDescription(row.data.estado)}`)}</TableCell>
              </ISTableRow>
            )}
          </TableBody>
        </Table>
        {props.loading &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={25} />
          </div>
        }
        {<PaginationButtons pagination={props.pagination} />}
      </TableContainer>
    </Stack>
  );
}

export default Carriers
